import { Country } from "@utils/constants/localisation";
import { IMSTokenParams, getWithIDToken } from "@utils/http/MSAuthAPI";


export interface IPlan {
    id: string
    name: string
    additionalDistCostPerUnit: number
    weeklyDistAllowance: number
    minimumPeriodWeeks: number
    weeklyHireFee: number
    NSWIncentiveTotalValue: string
    NSWIncentivePlanBeforeDiscount: string

    NSWWeeklyIncentiveExclGST: string | null
    NSWTotalIncentiveExclGST: string | null
};


interface IPlanService {
    getPlan(planId: string, country: Country, IDTokenParams: IMSTokenParams): Promise<IPlan>;
    getPlans(qParams: object, country: Country, IDTokenParams: IMSTokenParams): Promise<IPlan[]>;
};


export const PlanService: IPlanService = {

    async getPlan(planId: string, country: Country, IDTokenParams: IMSTokenParams): Promise<IPlan> {
        const encodedPlanId = encodeURIComponent(planId);
        const resp = await getWithIDToken(
            `/v1/plans/${encodedPlanId}/`,
            IDTokenParams,
            { country }
        );

        return {
            id: resp.data.id,
            name: resp.data.name,
            additionalDistCostPerUnit: Number(resp.data.additional_dist_cost_per_unit),
            weeklyDistAllowance: Number(resp.data.weekly_distance_allowance),
            minimumPeriodWeeks: Number(resp.data.minimum_period_weeks),
            weeklyHireFee: Number(resp.data.weekly_hire_fee),
            NSWIncentiveTotalValue: resp.data.nsw_ev_incentive_total,
            NSWIncentivePlanBeforeDiscount: resp.data.nsw_ev_incentive_value_before_discount,

            NSWWeeklyIncentiveExclGST: resp.data.nsw_weekly_ev_incentive_excl_gst,
            NSWTotalIncentiveExclGST: resp.data.nsw_total_ev_incentive_excl_gst,
        };
    },

    async getPlans(qParams: object, country: Country, IDTokenParams: IMSTokenParams): Promise<IPlan[]> {
        const resp = await getWithIDToken(
            '/v1/plans',
            IDTokenParams,
            { ...qParams, country }
        );

        return resp.data.map((item: any) => ({
            id: item.id,
            name: item.name,
            additionalDistCostPerUnit: Number(item.additional_dist_cost_per_unit),
            weeklyDistAllowance: Number(item.weekly_distance_allowance),
            minimumPeriodWeeks: Number(item.minimum_period_weeks),
            weeklyHireFee: Number(item.weekly_hire_fee),
            NSWIncentiveTotalValue: item.nsw_ev_incentive_total,
            NSWIncentivePlanBeforeDiscount: item.nsw_ev_incentive_value_before_discount,
        }));
    },
};
